import { CheckoutLoginParams, CheckoutLoginResponse } from "../../../packages/mkm-api/src/types";
import useMiddlewareCheck from "./useMiddlewareCheck";
import { useConfig } from "~/constants";

export const useCheckout = () => {
  const middlewareCheck = useMiddlewareCheck();

  const login = async ({ params }: CheckoutLoginParams) => {
    const { baseUrl, headers } = useConfig();

    const { data: result, error } = await useAsyncData<any>("checkoutLogin", () =>
      $fetch<CheckoutLoginResponse>(`${baseUrl}/checkoutLogin`, {
        headers,
        body: JSON.stringify({ params }),
        method: "POST",
        credentials: "include",
      }),
    );

    if (result.value?.status === 200) return result.value.redirectTo;

    useHandleError(error.value);
    middlewareCheck.checkIfSessionRelatedIssue(error.value);
    return result.value;
  };

  return {
    login,
  };
};

export default useCheckout;
